import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './Redux/Store/configureStore';
import { FeatureFlagsProvider } from './FeatureFlags/FeatureFlagsContext';

// Override console methods to suppress them, with a temporary exception for email migration debugging.
const nativeConsole = {
  log: console.log,
  warn: console.warn,
  error: console.error,
  info: console.info,
  debug: console.debug,
};

const shouldShowTemporaryDebugLog = (args) => typeof args?.[0] === 'string' && args[0].startsWith('[EailMigrationBanner DEBUG]');

console.log = (...args) => {
  if (shouldShowTemporaryDebugLog(args)) nativeConsole.log(...args);
};
console.warn = (...args) => {
  if (shouldShowTemporaryDebugLog(args)) nativeConsole.warn(...args);
};
console.error = (...args) => {
  if (shouldShowTemporaryDebugLog(args)) nativeConsole.error(...args);
};
console.info = (...args) => {
  if (shouldShowTemporaryDebugLog(args)) nativeConsole.info(...args);
};
console.debug = (...args) => {
  if (shouldShowTemporaryDebugLog(args)) nativeConsole.debug(...args);
};


ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter>
          <FeatureFlagsProvider>
            <App />
          </FeatureFlagsProvider>
        </BrowserRouter>
      </PersistGate>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

reportWebVitals();
